import { CATEGORY_TYPE } from './documents.model';

export enum COMPANY {
  CHEMISTRY = 'chemistry',
  BATTERY_PACKS_REPAIR = 'batteryPacksRepair',
  BATTERY_CELLS = 'batteryCells',
  BATTERY_REPURPOSE = 'batteryRepurpose',
  BATTERY_PACKS = 'batteryPacks',
  BATTERY_PACKS_RECYCLING = 'batteryPacksRecycling',
  BATTERY_TECH_REVIEW = 'batteriesTechReview',
  BATTERY_WASTE = 'batteryWaste',
  AUTHORITIES = 'authorities',
}

export type CurrentAccountModel = {
  name: string;
  company: COMPANY;
  category?: CATEGORY_TYPE;
  subCategories?: CATEGORY_TYPE[];
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  color: string;
  baseUrl: string;
  publisherId: string;
  isActive: boolean;
};
